import { render } from "./MSidebar.vue?vue&type=template&id=148243ae&scoped=true"
import script from "./MSidebar.vue?vue&type=script&lang=js"
export * from "./MSidebar.vue?vue&type=script&lang=js"

import "./MSidebar.vue?vue&type=style&index=0&id=148243ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148243ae"]])

export default __exports__